import { render } from "./CoursesView.vue?vue&type=template&id=47bfef4c"
import script from "./CoursesView.vue?vue&type=script&lang=js"
export * from "./CoursesView.vue?vue&type=script&lang=js"

import "./CoursesView.vue?vue&type=style&index=0&id=47bfef4c&lang=css"

import exportComponent from "/Users/meganma/Documents/Web Projects/meganm38.github.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__